// ========================================================================
// This file is auto-generated by the `yarn naptime:types` script
// ========================================================================
import NaptimeResource from 'bundles/naptimejs/resources/NaptimeResource';

// ========================================================================
// Definitions for resource data types
// ========================================================================

export type BrowsingExperienceValue = 'DEEP_BROWSE' | 'SMALL_SUBSET';

export interface ProgramBrowsingExperiencesV1 {
  id: string;
  browsingExperience: BrowsingExperienceValue;
  numCollections: number;
}

// ========================================================================
// Definitions for naptime-link
// ========================================================================

export interface ProgramBrowsingExperiencesV1Connection {
  elements: Array<ProgramBrowsingExperiencesV1> | null;
}

// ========================================================================
// Definitions for naptime-link queries
// ========================================================================

export interface ProgramBrowsingExperiencesV1GetQuery {
  ProgramBrowsingExperiencesV1: {
    get: ProgramBrowsingExperiencesV1Connection | null;
  } | null;
}

export interface ProgramBrowsingExperiencesV1GetQueryVariables {
  id: string;
  includes?: string | null;
}

export interface ProgramBrowsingExperiencesV1MultiGetQuery {
  ProgramBrowsingExperiencesV1: {
    multiGet: ProgramBrowsingExperiencesV1Connection | null;
  } | null;
}

export interface ProgramBrowsingExperiencesV1MultiGetQueryVariables {
  ids: string;
  includes?: string | null;
}

// ========================================================================
// Definitions for naptime-js
// ========================================================================

// Recursively applies Partial<T> to supported culling by the `fields` param.
type PartialConstruction<T> = {
  [TKey in keyof T]?: T[TKey] extends Array<infer TElement>
    ? Array<PartialConstruction<TElement>>
    : T[TKey] extends object
    ? PartialConstruction<T[TKey]>
    : T[TKey];
};

export class ProgramBrowsingExperiencesV1NaptimeResource extends NaptimeResource {
  static RESOURCE_NAME = 'programBrowsingExperiences.v1' as const;

  declare id: string;

  declare browsingExperience: BrowsingExperienceValue;

  declare numCollections: number;

  // Intentionally "useless" to supply params type
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(params: PartialConstruction<ProgramBrowsingExperiencesV1>) {
    super(params);
  }
}
